export { default } from "./BaseComponentConfigSection";
